export const TERMS_TYPE = {
  MEETING: 'MT',
  MESSENGER: 'MS',
  DRIVE: 'DV',
  PORTAL: 'PT',
  MOBILE: 'MO',
  REAGREEMENT: 'reagreement',
  AGREEMENT: 'agreement',
};

export const KEYCODE = {
  ESC: 'Escape',
  ENTER: 'Enter',
  NUMPADENTER: 'NumpadEnter',
  UP: 'ArrowUp',
  DOWN: 'ArrowDown',
};

export const ERROR_PAGE = `${window.location.origin}/userapp/error`;
export const MESSENGER_DOWNLOAD_URL = `${window.location.origin}/supportapp/download`;
export const DRIVE_URL_CONFIG = 'ep.drive.domain';
export const MEETING_URL_CONFIG = 'ep.meeting.domain';

export const PORTAL_MAIN = `${window.location.origin}`;
export const PORTAL_MAIN_URL_FREE_ADD = `${window.location.origin}/loginapp`;
export const PORTAL_LOGIN_MAIN = '/loginapp/login/session/privacy-policy-agreement';

export const TERMS_TITLE = {
  MEETING: {
    title: 'MB_T_BRITY_MT_TITLE',
    subTitle: 'MB_T_BRITY_MT_CONTENTS',
  },
  MESSENGER: {
    title: 'MB_T_BRITY_MS_TITLE',
    subTitle: 'MB_T_BRITY_MS_CONTENTS',
  },
  DRIVE: {
    title: 'MB_T_BRITY_DT_TITLE',
    subTitle: 'MB_T_BRITY_DT_CONTENTS',
  },
  PORTAL: {
    title: 'MB_T_BRITY_PT_TITLE',
    subTitle: 'MB_T_BRITY_PT_CONTENTS',
  },
  REGISTER: { title: 'MB_T_SIGNUP_TITLE' },
  REAGREEMENT: {
    title: 'MB_T_REAGRREMENT_T',
    subTitle: 'MB_T_REAGRREMENT_CONTENTS',
  },
  AGREEMENT: {
    title: 'MB_T_TERM_SERVICE',
  },
  INSTANT: {
    title: 'MB_T_NEW_SIGNUP_TITLE',
  },
};

export const getTermsTitle = svcType => {
  let termsTitle = '';
  switch (svcType) {
    case TERMS_TYPE.MEETING:
      termsTitle = TERMS_TITLE.MEETING;
      break;
    case TERMS_TYPE.MESSENGER:
      termsTitle = TERMS_TITLE.MESSENGER;
      break;
    case TERMS_TYPE.DRIVE:
      termsTitle = TERMS_TITLE.DRIVE;
      break;
    case TERMS_TYPE.PORTAL:
      termsTitle = TERMS_TITLE.PORTAL;
      break;
    case 'instant':
      termsTitle = TERMS_TITLE.INSTANT;
      break;
    case TERMS_TYPE.REAGREEMENT:
      termsTitle = TERMS_TITLE.REAGREEMENT;
      break;
    case TERMS_TYPE.AGREEMENT:
      termsTitle = TERMS_TITLE.AGREEMENT;
      break;
    default:
      termsTitle = TERMS_TITLE.REGISTER;
      break;
  }
  return termsTitle;
};

export const getsvcCode = svcType => {
  let svcCode = '';
  switch (svcType) {
    case TERMS_TYPE.MEETING:
      svcCode = `${TERMS_TYPE.MEETING}|${TERMS_TYPE.MESSENGER}`;
      break;
    case TERMS_TYPE.MESSENGER:
      svcCode = `${TERMS_TYPE.MESSENGER}|${TERMS_TYPE.MEETING}`;
      break;
    case TERMS_TYPE.DRIVE:
      svcCode = TERMS_TYPE.DRIVE;
      break;
    case TERMS_TYPE.PORTAL:
      svcCode = `${TERMS_TYPE.PORTAL}|${TERMS_TYPE.MESSENGER}|${TERMS_TYPE.MEETING}|${TERMS_TYPE.MOBILE}|${TERMS_TYPE.DRIVE}`;
      break;
    default:
      break;
  }
  return svcCode;
};

export const SIGNUP_RADIO = [
  {
    value: 'mobile',
    title: 'MB_T_EMP_MOBILE',
    label: 'MB_T_EMP_MOBILE',
  },
  { value: 'epExternalMail', label: 'MB_T_EMP_EX_EMAIL', title: 'MB_T_EMP_EX_EMAIL' },
  { value: 'epOpenCode', label: 'MB_T_EMP_CERT_KEY', title: 'MB_T_EMP_CERT_KEY' },
];

export const SIGNUP_RADIO_ERROR = {
  mobile: 'MB_M_PHONENUMBER_NOT_EXIST',
  epExternalMail: 'MB_M_PWD_ENTER_EXTMAIL',
  epOpenCode: 'MB_M_ID_EPOPEN_CODE',
};

export const PASSWORD_RULE = {
  PASSWORD_NOREAT: 3,
  PASSWORD_NOSEQNUM: 3,
  PASSWORD_MIN: 8,
  PASSWORD_MAX: 12,
  PASSWORD_CUR_MIN: 6,
};
export const EXTERNALEMAIL_BRITY_WORKS = ['@dev.brityworks.com', '@stage.brityworks.com', '@brityworks.com'];

export const EXTERNALEMAIL_BRITY_MAIL = ['@dev.britymail.com', '@stage.britymail.com', '@britymail.com'];

export const ALERT_CONFIRM_MODAL_SIZE = {
  xs: {
    width: 384,
    height: 192,
  },
};

export const TRMS_CD = {
  PIFNGO: 'PIFNGO',
};
